module.exports = __webpack_public_path__ + "static/first-2b1c34f99974650dbdd61325d3512f25.jpg";